import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from 'theme/theme';
import utils from 'helpers/utils';
import { Link } from 'react-router-dom';

const TextFieldWrapper = styled.div`
    margin: 0 0 20px 0;
`;

const Title = styled(Link)`
    font-size: 15px;
    font-weight: bold;
    line-height: 1.4;
    text-decoration: underline;
    color: ${ theme.palette.black }
`;

const Text = styled.div`
    font-size: 14px;
    line-height: 1.4;
`;

const Box = styled.div`
    margin: 1rem 0 0 0;
`;

/**
 * This component will render the Product information for the Order Show page.
 * In case of an Transfer or Taxi we won't have a any addresses availble.
 *
 * @param {*} props
 */
const ProductShowField = (props) => {
    const { product } = props;

    if (utils.isEmpty(product)) {
        return null;
    }

    const generateAddress = function (string) {
        if (!string) {
            return null;
        }

        const items = string.split(',');

        for (let i = 0; i < items.length; i++) {
            items[i] = `${ items[i] } \n`;
        }

        return {
            street: items[0],
            zipcode: items[1],
        };
    };

    const address = generateAddress(product.location_address);

    return (
        <TextFieldWrapper>
            <Title to={ `/products/${ product.id }/show` }>{ utils.firstCharToCamelCase(product.title) }</Title>

            { address &&
                <div>
                    <Text>{ address.street }</Text>

                    <Text>{ address.zipcode }</Text>
                </div>
            }

            { !utils.isEmpty(product.phone) &&
                <Box>
                    <Text>P: { product.phone }</Text>
                </Box>
            }
        </TextFieldWrapper>
    );
};

ProductShowField.propTypes = {
    product: PropTypes.shape({
        id: PropTypes.string,
        location_address: PropTypes.string,
        phone: PropTypes.string,
        title: PropTypes.string.isRequired,
    }).isRequired,
};

export default ProductShowField;



// WEBPACK FOOTER //
// ./src/components/show/ProductShowField.js